import { config } from "../../config"
import { zip } from "../../helpers/utils"

export const qa = {
  generate: ({ token, text }) => {
    const url = config.apiUrl + `/engine/text/qa`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(text),
      }

    return { url, opt }
  },

  readOne: ({ id }) => {
    const base = config.apiUrl + `/qa/${id}`,
      opt = {}

    return { url: base, opt }
  },

  readAll: ({ from = null, limit = null, match = null }) => {
    const base = config.apiUrl + `/qa`,
      opt = {}

    const params = zip([from, limit, match], ["f", "l", "q"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },

  create: ({ token, qa }) => {
    const url = config.apiUrl + `/qa`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(qa),
      }

    return { url, opt }
  },

  update: ({ token, qa_id, qa }) => {
    const url = config.apiUrl + `/qa/${qa_id}`,
      opt = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...qa }),
      }

    return { url, opt }
  },

  delete: ({ token, qa_id }) => {
    const url = config.apiUrl + `/qa/${qa_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },

  // add_respuesta: ({ qa_id, contenido }) => {
  //   const url = config.apiUrl + `/qa/${qa_id}/respuestas`
  //       , opt = {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify( { contenido } )
  //     }

  //   return { url, opt }
  // },

  // respuestas: {
  //   readOne: ({ qa_id, res_id }) => {
  //     const base = config.apiUrl + `/qa/${qa_id}/respuestas/${res_id}`
  //         , opt = {}

  //     return { url: base, opt }
  //   },

  //   marcas: {
  //     create: ({ token, qa_id, res_id, marca }) => {
  //       const base = config.apiUrl + `/qa/${qa_id}/respuestas/${res_id}/marcas`
  //           , opt = {
  //                 method: 'POST',
  //                 headers: {
  //                   'Authorization': `Bearer ${token}`,
  //                   'Content-Type': 'application/json'
  //                 },
  //                 body: JSON.stringify( marca )

  //             }

  //       return { url: base, opt }
  //     },
  //     update: ({ token, qa_id, res_id, marca_id, marca }) => {
  //       const base = config.apiUrl + `/qa/${qa_id}/respuestas/${res_id}/marcas/${marca_id}`
  //           , opt = {
  //                 method: 'PUT',
  //                 headers: {
  //                   'Authorization': `Bearer ${token}`,
  //                   'Content-Type': 'application/json'
  //                 },
  //                 body: JSON.stringify( marca )

  //             }

  //       return { url: base, opt }
  //     },
  //     delete: ({ token, qa_id, res_id, marca_id }) => {
  //       const base = config.apiUrl + `/qa/${qa_id}/respuestas/${res_id}/marcas/${marca_id}`
  //           , opt = {
  //                 method: 'DELETE',
  //                 headers: {
  //                   'Authorization': `Bearer ${token}`,
  //                   'Content-Type': 'application/json'
  //                 }
  //             }

  //       return { url: base, opt }
  //     },
  //   }
  // }
}
